import React, { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import { Button, Icon } from 'semantic-ui-react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { LoadingPage } from 'Components';
import { ReactTableColumnProperties } from 'Common/Constants';
import { CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME } from 'Common/FormEnum';
import { resetForm } from 'State/forms/actions';
import { makeOptionsDataRemoveEmpty } from 'Common/FormHelper';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { errorToast } from 'Common/ToastHelper';
import { AvailableKitchenPrepWorksheetEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { HeaderLeftAlign } from 'Common/Constants/table';

import { BASE_URL } from '../../helper/createEditPrepWorksheet';
import * as Selectors from './../../state/availableKitchenPrepWorksheet/selectors';
import AvailableKitchenPrepWorksheetComponent from './../../components/availableKitchenPrepWorksheet/AvailableKitchenPrepWorksheetComponent';
import {
  getKitchenList,
  changeDropDownData,
  getAvailableKitchenPrepWorksheetItems,
  emptyAvailableTableData,
  clearAvailableKitchenPrepError,
  setFromDateMax,
  setToDateMin,
  resetDateRange,
} from './../../state/availableKitchenPrepWorksheet/actions';

class AvailableKitchenPrepWorksheetContainer extends Component {
  static propTypes = {
    kitchenListLoading: PropTypes.bool.isRequired,
    kitchenListData: PropTypes.array.isRequired,
    kitchenListLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    availableKitchenData: PropTypes.array.isRequired,
    availableKitchenDataLoading: PropTypes.bool.isRequired,
    availableKitchenDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fromDateMax: PropTypes.object.isRequired,
    toDateMin: PropTypes.object.isRequired,

    getKitchenList: PropTypes.func.isRequired,
    changeDropDownData: PropTypes.func.isRequired,
    getAvailableKitchenPrepWorksheetItems: PropTypes.func.isRequired,
    emptyAvailableTableData: PropTypes.func.isRequired,
    clearAvailableKitchenPrepError: PropTypes.func.isRequired,
    setFromDateMax: PropTypes.func.isRequired,
    setToDateMin: PropTypes.func.isRequired,
    resetDateRange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    availableKitchenDataError: null,
    kitchenListLoadingError: null,
  };

  reactTableRef = React.createRef();

  state = {
    activeIndexForFilter: 0,
    expanded: [],
    sorted: [],
    filtered: [],
    page: 0,
  };

  columns = [
    {
      expander: true,
      Header: '',
      width: 40,
      accessor: AvailableKitchenPrepWorksheetEnum.Expander,
      id: 'Expander',
      Expander: ({ isExpanded }) => {
        let props = {};

        if (isExpanded) {
          props = { rotated: 'clockwise' };
        }

        return <Icon name="caret right" {...props} />;
      },
      sortable: false,
    },
    {
      Header: () => <span className="ml-5">Delivery Date</span>,
      accessor: AvailableKitchenPrepWorksheetEnum.DeliveryDate,
      id: 'Delivery Date',
      ...HeaderLeftAlign,
      ...ReactTableColumnProperties,
    },
    {
      Header: '',
      accessor: AvailableKitchenPrepWorksheetEnum.CreateBtn,
      ...ReactTableColumnProperties,
      filterable: false,
      sortable: false,
      width: 120,
      Cell: ({ original }) => {
        return (
          <div>
            <Button
              content="Create"
              size="medium"
              type={'button'}
              onClick={e => this.onCreateClick(e, original)}
            />
          </div>
        );
      },
    },
  ];

  componentDidMount = async () => {
    await this.props.getKitchenList();
    const kitchenOptions = makeOptionsDataRemoveEmpty(
      this.props.kitchenListData
    );
    const selectedKitchen = this.props.selectedKitchenId
      ? this.props.selectedKitchenId
      : kitchenOptions[0].value;
    if (kitchenOptions.length > 0) {
      this.props.changeDropDownData(
        AvailableKitchenPrepWorksheetEnum.Kitchen,
        selectedKitchen
      );
    }
    this.getFilteredData(
      selectedKitchen,
      AvailableKitchenPrepWorksheetEnum.Kitchen
    );
  };

  componentDidUpdate(prevProps) {
    const { clearAvailableKitchenPrepError } = this.props;
    if (
      errorToast(this.props, prevProps, 'kitchenListLoadingError') ||
      errorToast(this.props, prevProps, 'availableKitchenDataError')
    ) {
      clearAvailableKitchenPrepError();
    }
  }

  onCreateClick = (e, row) => {
    const { selectedKitchenId } = this.props;
    const deliveryDt = moment(row.DeliveryDate).format(DATE_FORMAT_FOR_SERVER);
    this.props.history.push(
      `${BASE_URL}/0/0/${deliveryDt}/${selectedKitchenId}`
    );
  };

  setExpandedState = expanded => {
    this.setState({ expanded });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexForFilter } = this.state;
    const newIndex = activeIndexForFilter === index ? -1 : index;
    this.setState({
      activeIndexForFilter: newIndex,
    });
  };

  onDropDownChange = (kitchenId, field) => {
    this.getFilteredData(kitchenId, field);
  };

  onChangeOfFromDT = (e, fromDT, prevDate, field) => {
    this.props.setToDateMin(moment(fromDT, DATE_FORMAT_FOR_UI));
    this.getFilteredData(fromDT, field);
  };

  onChangeOfToDT = (e, toDate, prevDate, field) => {
    this.props.setFromDateMax(moment(toDate, DATE_FORMAT_FOR_UI));
    this.getFilteredData(toDate, field);
  };

  clearFilters = () => {
    this.setState({
      sorted: [],
      filtered: [],
      page: 0,
    });
    this.completeReset();
    const kitchenOptions = makeOptionsDataRemoveEmpty(
      this.props.kitchenListData
    );
    if (kitchenOptions.length > 0) {
      this.props.changeDropDownData(
        AvailableKitchenPrepWorksheetEnum.Kitchen,
        kitchenOptions[0].value
      );
    }
    this.props.emptyAvailableTableData();
    this.props.resetDateRange();
  };

  completeReset = () => {
    this.props.resetForm(CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME);
  };

  onSortedChange = (sorted, column, shiftKey) => {
    this.setState({ sorted, page: 0 });
  };

  onFilteredChange = (filtered, column) => {
    this.setState({ filtered, page: 0 });
  };

  onPageChange = page => {
    this.setState({ page });
  };

  onPageSizeChange = (currentPageSize, currentPage) => {
    this.setState({
      page: currentPage,
    });
  };

  getFilteredData = (value, field) => {
    const { selectedKitchenId, selectedFromDate, selectedToDate } = this.props;
    let fromDate = selectedFromDate;
    let toDate = selectedToDate;
    let kitchenId = selectedKitchenId;
    if (field === AvailableKitchenPrepWorksheetEnum.BeginDT) {
      fromDate = value;
    } else if (field === AvailableKitchenPrepWorksheetEnum.EndDT) {
      toDate = value;
    } else {
      kitchenId = value;
    }
    const reqObj = {
      FromDate: moment(fromDate).format(DATE_FORMAT_FOR_SERVER),
      ToDate: moment(toDate).format(DATE_FORMAT_FOR_SERVER),
      KitchenId: kitchenId,
    };
    this.props.getAvailableKitchenPrepWorksheetItems(reqObj);
  };

  render() {
    const {
      kitchenListLoading,
      fromDateMax,
      toDateMin,
      availableKitchenData,
      availableKitchenDataLoading,
    } = this.props;
    const {
      activeIndexForFilter,
      expanded,
      sorted,
      filtered,
      page,
    } = this.state;
    return kitchenListLoading ? (
      <LoadingPage />
    ) : (
      <AvailableKitchenPrepWorksheetComponent
        activeIndexForFilter={activeIndexForFilter}
        handleClick={this.handleClick}
        onChangeOfFromDT={this.onChangeOfFromDT}
        onChangeOfToDT={this.onChangeOfToDT}
        fromDateMax={fromDateMax}
        toDateMin={toDateMin}
        onDropDownChange={this.onDropDownChange}
        clearFilters={this.clearFilters}
        columns={this.columns}
        reactTableRef={this.reactTableRef}
        expanded={expanded}
        setExpandedState={this.setExpandedState}
        availableKitchenData={availableKitchenData}
        availableKitchenDataLoading={availableKitchenDataLoading}
        sorted={sorted}
        onSortedChange={this.onSortedChange}
        filtered={filtered}
        onFilteredChange={this.onFilteredChange}
        page={page}
        onPageChange={this.onPageChange}
        onPageSizeChange={this.onPageSizeChange}
      />
    );
  }
}

AvailableKitchenPrepWorksheetContainer = reduxForm({
  form: CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AvailableKitchenPrepWorksheetContainer);

const selector = formValueSelector(
  CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME
);
const mapStateToProps = state => {
  return {
    selectedKitchenId: selector(
      state,
      AvailableKitchenPrepWorksheetEnum.Kitchen
    ),
    selectedFromDate: selector(
      state,
      AvailableKitchenPrepWorksheetEnum.BeginDT
    ),
    selectedToDate: selector(state, AvailableKitchenPrepWorksheetEnum.EndDT),
    kitchenListLoading: Selectors.getKitchenListLoading(state),
    kitchenListData: Selectors.getKitchenListFilteredData(state),
    kitchenListLoadingError: Selectors.getKitchenListLoadingError(state),
    availableKitchenData: Selectors.getAvailableKitchenFormattedData(state),
    availableKitchenDataLoading: Selectors.getAvailableKitchenDataLoading(
      state
    ),
    availableKitchenDataError: Selectors.getAvailableKitchenDataError(state),
    fromDateMax: Selectors.getFromDateMax(state),
    toDateMin: Selectors.getToDateMin(state),
  };
};

const mapDispatchToProps = {
  resetForm,
  getKitchenList,
  changeDropDownData,
  getAvailableKitchenPrepWorksheetItems,
  emptyAvailableTableData,
  clearAvailableKitchenPrepError,
  setFromDateMax,
  setToDateMin,
  resetDateRange,
};

export const AvailableKitchenPrepWorksheet = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AvailableKitchenPrepWorksheetContainer)
);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/containers/availablePrepWorksheet/AvailableKitchenPrepWorksheet.js